import NotificationIcon from "@mui/icons-material/NotificationImportant";
import { NotificationCard } from "./NotificationCard";
import { IconButton } from "@mui/material";
import Close from "@mui/icons-material/Close";
import styled, { css } from "styled-components/macro";
import { BREAKPOINT_TABLET } from "constants/constants";

/**
 * Indicates that you're looking at a serial / bottleneck process
 * where rollups & metrics are calculated based on a limited set of processes
 * instead of the full set
 */
const IsSerialProcessIndicator = ({
  isIndicatorOpen,
  setIsIndicatorOpen,
  setIsSerialProcessTourEnabled,
}) =>
  isIndicatorOpen ? (
    <NotificationCard
      {...{
        message: (
          <MessageStyles>
            <div>This is a serial process</div>
            <div
              className="find-out-more"
              onClick={() => {
                setIsSerialProcessTourEnabled(true);
              }}
            >
              Find out more...
            </div>
          </MessageStyles>
        ),
        icon: <NotificationIcon style={{ transform: "scale(1.1)" }} />,
        variant: "info",
        customCss: css`
          margin: 5px;
          @media (min-width: ${BREAKPOINT_TABLET}px) {
            margin: 5px 10px;
          }
        `,
        ActionButton: (
          <IconButton
            onClick={() => {
              setIsIndicatorOpen(false);
            }}
          >
            <Close />
          </IconButton>
        ),
      }}
    />
  ) : null;
export default IsSerialProcessIndicator;

const MessageStyles = styled.div`
  .find-out-more {
    font-size: 13px;
    text-decoration: underline;
    margin-top: -4px;
    cursor: pointer;
    &:hover {
      opacity: 0.6;
    }
  }
`;
